<template>
    <div class="row">
        <div class="form-group col-lg-6">
            <label class="font-weight-bold">{{ $t('otherFields.other1') }}</label>
            <textarea class="form-control" v-model="otherFields.other1" :maxlength="maxLength"/>
            <p>{{$t('remainingSymbols')}} {{charactersRemainingField1}}</p>
        </div>
        <div class="form-group col-lg-6">
            <label class="font-weight-bold">{{ $t('otherFields.other2') }}</label>
            <textarea class="form-control" v-model="otherFields.other2" :maxlength="maxLength"/>
            <p>{{$t('remainingSymbols')}} {{charactersRemainingField2}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            otherFields: {
                type: Object
            },
            maxLength: {
            type: Number,
            default: 500
            }
        },
        computed: {
            charactersRemainingField1: function() {
                return this.maxLength - this.otherFields.other1.length;
            },
            charactersRemainingField2: function() {
                return this.maxLength - this.otherFields.other2.length;
            }
        }
    }
</script>
